const stylesheet = `
.react-jinke-music-player-main.light-theme .loading svg {
    color: #2e7de9;
    font-size: 24px
}

.react-jinke-music-player-mobile-play-model-tip {
    background-color: #2e7de9;
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle, .react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-track {
    background-color: #2e7de9
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle:active {
    box-shadow: 0 0 2px #2e7de9
}

.react-jinke-music-player-main.light-theme .audio-item.playing svg {
    color: #2e7de9
}

.react-jinke-music-player-main.light-theme .audio-item.playing .player-singer {
    color: #2e7de9 !important
}

.audio-lists-panel-content .audio-item.playing, .audio-lists-panel-content .audio-item.playing svg {
    color: #2e7de9
}

.audio-lists-panel-content .audio-item:active .group:not(.player-delete) svg, .audio-lists-panel-content .audio-item:hover .group:not(.player-delete) svg {
    color: #2e7de9
}

.react-jinke-music-player-main.light-theme ::-webkit-scrollbar-thumb {
    background-color: #2e7de9;
}

.react-jinke-music-player-main.light-theme svg {
    color: #3760bf
}

.react-jinke-music-player-main.light-theme svg:active, .react-jinke-music-player-main.light-theme svg:hover {
    color: #2e7de9
}

.react-jinke-music-player-main.light-theme .rc-slider-rail {
    background-color: rgba(55, 96, 191, .12) !important
}

.react-jinke-music-player-main.light-theme .music-player-controller {
    background-color: #d5d6db;
    border-color: #d5d6db
}

.react-jinke-music-player-main.light-theme .music-player-panel {
    background-color: #d5d6db;
    box-shadow: 0 1px 2px 0 rgba(0, 34, 77, .05);
    color: #3760bf
}

.react-jinke-music-player-main.light-theme .music-player-panel .img-content {
    box-shadow: 0 0 10px #c4c8da
}

.react-jinke-music-player-main.light-theme .music-player-panel .progress-load-bar {
    background-color: rgba(55, 96, 191, .08) !important
}

.react-jinke-music-player-main.light-theme .rc-switch {
    color: #fff
}

.react-jinke-music-player-main.light-theme .rc-switch:after {
    background-color: #fff
}

.react-jinke-music-player-main.light-theme .rc-switch-checked {
    background-color: #2e7de9 !important;
    border: 1px solid #2e7de9
}

.react-jinke-music-player-main.light-theme .rc-switch-inner {
    color: #fff
}

.react-jinke-music-player-main.light-theme .audio-lists-btn {
    background-color: #e1e2e7 !important
}

.react-jinke-music-player-main.light-theme .audio-lists-btn:active, .react-jinke-music-player-main.light-theme .audio-lists-btn:hover {
    background-color: #ebebed;
    color: #3760bf
}

.react-jinke-music-player-main.light-theme .audio-lists-btn > .group:hover, .react-jinke-music-player-main.light-theme .audio-lists-btn > .group:hover > svg {
    color: #2e7de9
}

.react-jinke-music-player-main.light-theme .audio-lists-panel {
    background-color: #d5d6db;
    box-shadow: 0 0 2px #c4c8da;
    color: #3760bf
}

.react-jinke-music-player-main.light-theme .audio-lists-panel .audio-item {
    background-color: #d5d6db
}

.react-jinke-music-player-main.light-theme .audio-lists-panel .audio-item:nth-child(odd) {
    background-color: #dadbe0 !important
}

.react-jinke-music-player-main.light-theme .audio-lists-panel .audio-item.playing {
    background-color: #c4c8da !important
}

.react-jinke-music-player-main.light-theme .audio-lists-panel .audio-item.playing, .react-jinke-music-player-main.light-theme .audio-lists-panel .audio-item.playing svg {
    color: #2e7de9 !important
}
`

export default stylesheet
